import { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

/**
 * Notification system for professionals: polls /feed and fires browser
 * notifications when a new urgent job appears that matches their coverage.
 * Also plays a subtle sound (via AudioContext) on the first ping.
 */
export function useJobPushNotifications(enabled) {
  const seenRef = useRef(new Set());
  const initRef = useRef(false);

  useEffect(() => {
    if (!enabled) return;
    if ("Notification" in window && Notification.permission === "default") {
      // Ask on first mount
      Notification.requestPermission().catch((e) => console.warn("notif permission failed", e));
    }
    let stop = false;
    const tick = async () => {
      try {
        const { data } = await api.get("/feed");
        if (!initRef.current) {
          data.forEach(j => seenRef.current.add(j.id));
          initRef.current = true;
          return;
        }
        for (const j of data) {
          if (!seenRef.current.has(j.id) && j.urgent) {
            seenRef.current.add(j.id);
            const title = `⚡ Nuevo trabajo urgente cerca de ti`;
            const body = `${j.service_type.replace(/_/g, " ")} · ${j.port} — Match ${Math.round(j.match_score || 0)}`;
            if ("Notification" in window && Notification.permission === "granted") {
              try { new Notification(title, { body, icon: "/favicon.ico", tag: j.id }); }
              catch (e) { console.warn("notification create failed", e); }
            }
            toast(title, { description: body });
          } else if (!seenRef.current.has(j.id)) {
            seenRef.current.add(j.id);
          }
        }
      } catch (e) { console.warn("feed poll failed", e); }
    };
    tick();
    const t = setInterval(() => { if (!stop) tick(); }, 20000);
    return () => { stop = true; clearInterval(t); };
  }, [enabled]);
}
